var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.userLogin)?_c('Navbar'):_vm._e(),_c('div',{staticClass:"main"},[(this.userLogin)?_c('div',{staticClass:"sideBar"},[_c('Sidebar')],1):_vm._e(),_c('div',{staticClass:"routePage"},[_c('router-view')],1)]),(this.userLogin)?_c('div',{staticClass:"footer"},[_c('Footer')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }